function movieGalleryInit() {

	var $galleryThumbsItem = document.querySelectorAll('.gallery-thumbs-item'), 
		$galleryThumbsItemOne = $galleryThumbsItem[0],
		$galleryBigItemsMovie = document.querySelectorAll('.gallery-big-item--movie'),
		windowWidth = window.innerWidth,
		sidebarWidth = document.querySelector('.sidebar').offsetWidth;

	setTimeout(function() {
		$('.gallery-big-item--movie').width($(window).width() - $('.sidebar').width());
	}, 200);

	$('.gallery-big--movie').slick({
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		autoplay: false,
		variableWidth: true,
		autoplaySpeed: 3000,
		cssEase: 'cubic-bezier(0.75,0.25,0.25,1)',
		dots: false,
		arrows: true,
		fade: true,
		prevArrow: '<span class="slick-prev"></span>',
		nextArrow: '<span class="slick-next"></span>'
	});

	$('.gallery-thumbs').slick({
		slidesToShow: 12,
		slidesToScroll: 1,
		asNavFor: '.gallery-big--movie',
		focusOnSelect: true,
		variableWidth: true,
		responsive: [{
		    breakpoint: 1280,
		    settings: {
		    	slidesToShow: 3
		    }
		}, 
		{
		    breakpoint: 768,
		    settings: {
		    	slidesToShow: 2
		    }
		},
		{
		    breakpoint: 480,
		    settings: {
		        slidesToShow: 1
		    }
		}]
	});

	$('.gallery-big--movie').on('afterChange', function(event, slick, currentSlide, nextSlide){

		for (var i = 0; i < $galleryThumbsItem.length; i++) {
			$galleryThumbsItem[i].classList.remove('active');
		}

    	$('.gallery-thumbs-item').each(function(){
	    	if(this.getAttribute('data-slick-index') == currentSlide && !this.hasClass('slick-cloned') ) {
		    	this.classList.add('active');
	    	}
    	});
	});

	$galleryThumbsItemOne.classList.add('active');

	var videoFill = function(){
		if('objectFit' in document.documentElement.style === false) {
			var count = 0;
			var slick = $('.gallery-big--movie');

			$('.v-holder').each(function(){
		        webWidth = $(slick).width();
		        webHeight = $(slick).height();

		        videoCur =  document.getElementById('vid-'+count);
		        imgHeight 	= videoCur.videoHeight;
		        imgWidth	= videoCur.videoWidth;

		        webScale = webHeight/webWidth;
		        imgScale = imgHeight/imgWidth;

		        if(webScale<imgScale){
		        	$(this).find('.v-holder-inner').css('margin-left','0');
		        	$(this).find('.v-holder-inner').width(webWidth+'px');

		            $(this).find('.v-holder-inner').height(parseInt((webWidth*imgScale))+1+'px');
		            $(this).find('.v-holder-inner').css('margin-top',parseInt((webHeight-((webWidth*imgScale)+1))/2)+'px');      
		        }
		        else {
		        	$(this).find('.v-holder-inner').css('margin-top','0');
		        	$(this).find('.v-holder-inner').height(webHeight+'px');

		            $(this).find('.v-holder-inner').width(parseInt((webHeight/imgScale))+1+'px');
		            $(this).find('.v-holder-inner').css('margin-left',parseInt(((webWidth-(webHeight/imgScale)+1))/2)+'px');      
		        }
		        count++;
			});
		}
	}

	var PlayFirstMovie = function(){
		$firstSlide = $('.gallery-big-hld--movies .slick-track .gallery-big-item--movie').first();
		
		if($firstSlide.hasClass('video')){

			$firstSlide.find('video source').each(function(){
				$videoAttrSrc = $(this).attr("src");

				if(typeof $videoAttrSrc !== typeof undefined && $videoAttrSrc !== false) {
					$firstSlide.find('video')[0].load();
				}
			});
		}
		videoFill();
	};

	$('.v-holder .hidden-trigger-video').on('click',function(){
		
		$(this).parent().addClass('playing').find('video')[0].play();
		$(this).parent().addClass('playing').find('video')[0].onended = function(){
			$(this).parent().parent().removeClass('playing');
		};
			
	});

	$('.v-holder .hidden-video-pause').on('click',function(){

		if($(this).parent().find('video')[0].paused == false){
			$(this).closest('.video-hld').removeClass('playing').find('video')[0].pause();
		}

	});

	$('.gallery-big--movie').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		$activeSlide = $('.gallery-big--movie .slick-track .slick-active');

		$activeSlide.find('.v-holder').removeClass('playing');
		$activeSlide.find('video')[0].pause();

		$lastSlide = $('.gallery-big--movie .slick-track .gallery-big-item--movie').last();
		$firstSlide = $('.gallery-big--movie .slick-track .gallery-big-item--movie').first();

		if( $('.gallery-big--movie .slick-track .gallery-big-item--movie').eq(nextSlide).length ) {

			if( $('.gallery-big--movie .slick-track .gallery-big-item--movie').eq(nextSlide).hasClass('video') ) {

				$('.gallery-big--movie .slick-track .gallery-big-item--movie').eq(nextSlide).find('video').each(function(){

					$videoAttrSrc = $(this).find('source').attr("data-src");
					if(typeof $videoAttrSrc !== typeof undefined && $videoAttrSrc !== false) {
						$(this).find('source').attr("src", $videoAttrSrc);
						$(this).find('source').removeAttr("data-src");
					}
				});

				$videoSrc = $('.gallery-big--movie .slick-track .gallery-big-item--movie').eq(nextSlide).find('video source').attr("src");

				if(typeof $videoSrc !== typeof undefined && $videoSrc !== false) {
					$('.gallery-big--movie .slick-track .gallery-big-item--movie').eq(nextSlide).find('video')[0].load();
				}
			}

		} else if( $lastSlide.hasClass('slick-active') ) {

			if( $firstSlide.hasClass('video') ) {

				$firstSlide.find('video').each(function(){

					$videoAttrSrc = $(this).find('source').attr("data-src");
					if(typeof $videoAttrSrc !== typeof undefined && $videoAttrSrc !== false) {
						$(this).find('source').attr("src", $videoAttrSrc);
						$(this).find('source').removeAttr("data-src");
					}
				});

				$videoSrc = $firstSlide.find('video source').attr("src");

				if(typeof $videoSrc !== typeof undefined && $videoSrc !== false) {
					$firstSlide.find('video')[0].load();
				}
			}

		}
	});

}

module.exports = movieGalleryInit;